import { atom } from "recoil";

export const adultState = atom<boolean>({
  key: "adultState",
  default: false,
});
